import { IonButton, IonItemDivider } from '@ionic/react';
import React, { useContext, useState } from 'react';
import { UserContext } from '../../contexts';
import { Expert } from '../../models';
import { Avatar } from '../global';
import { Search } from '../icons';
import { ConversationSearch } from './ConversationSearch';

export const ExpertHeader: React.FC = () => {
  const { user } = useContext(UserContext);
  const expert = user as Expert;
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <>
      <IonItemDivider className="expert-header">
        <div className="header-image">
          <Avatar user={expert} />
        </div>
        <div className={'ion-color-black'}>&nbsp; {expert.name}</div>
        <IonButton
          fill="clear"
          size="small"
          slot="end"
          onClick={() => setSearchOpen(!searchOpen)}
          className="search-toggle-btn"
        >
          <Search />
        </IonButton>
      </IonItemDivider>
      {searchOpen && (
        <ConversationSearch onClose={() => setSearchOpen(false)} />
      )}
    </>
  );
};
